export const lisaMainInteractions = [
    {
        id: 1,
        label: 'Drink (5$)',
        disabled: false
    },
    {
        id: 2,
        label: 'Hi, how are you?',
        disabled: true
    },
    {
        id: 13,
        label: 'Help at the bar',
        disabled: true
    },
    {
        id: 3,
        label: '(Interact...)',
        disabled: true
    }
]

export const lisaHomeInteractions = [
    {
        id: 4,
        label: 'Say Hi',
        disabled: false
    },
    {
        id: 5,
        label: '(Interact...)',
        disabled: true
    },
    {
        id: 6,
        label: 'Dates',
        disabled: true
    },
    {
        id: 7,
        label: 'Make Love',
        disabled: true
    }
]

export const lisaHomeSexInteractions = [
    {
        id: 8,
        label: 'Blowjob',
        disabled: false
    },
    {
        id: 10,
        label: 'Sex',
        disabled: false
    }
]

export const lisaHomeDatesInteractions = [
    {
        id: 9,
        label: 'Netflix & Chill',
        disabled: true
    },
    {
        id: 11,
        label: 'Beach',
        disabled: false
    },
    {
        id: 12,
        label: 'Park',
        disabled: true
    }
]
